module.exports = __webpack_public_path__ + "static/media/guarantee.35958213.png";